import { AxiosError } from 'axios';
import { QueryConfig, useQuery } from 'react-query';
import { __DEV__ } from '~src/config';
import { loadModules, LoadModulesReturnType } from '~src/services/api/modules';
import { useProjectId } from '../useProjectId';

export const useModules = (
  queryConfig: QueryConfig<LoadModulesReturnType, AxiosError> & {
    enabled?: boolean;
  } = {}
) => {
  const projectId = useProjectId();
  const { enabled, ...options } = queryConfig;

  // if enabled = undefined then enabled = true
  const enabledOverwrite = enabled || enabled === undefined;

  const modulesQuery = useQuery<LoadModulesReturnType, AxiosError>(
    [
      'modulesList',
      {
        projectId: String(projectId),
      },
    ],
    loadModules,
    {
      staleTime: 60 * 1000, // 1min
      enabled: enabledOverwrite && projectId,
      refetchOnWindowFocus: !__DEV__,
      ...options,
    }
  );

  return modulesQuery;
};
